<!-- menu-reservas.svelte -->
<script>

	import Rooming from './rooming.svelte'	

	let selector = 'rooming'

</script>


<ul class="nav border-bottom toolbar px-2">
	<li class="nav-item">
		<a class="nav-link" aria-current="page" href={"#"} on:click={()=>selector='rooming'}>Rooming</a>
	</li>
	<li class="nav-item">
		<a class="nav-link" href="{'#'}" on:click={()=>selector='grilla'}>Grilla</a>
	</li>
	<!--
	<li class="nav-item">
		<a class="nav-link" href="#">Link</a>
	</li>
	<li class="nav-item">
		<a class="nav-link disabled">Disabled</a>
	</li>
	-->
</ul>

{#if selector==='rooming'}
	<Rooming />
	
{/if}

{#if selector==='grilla'}
	<div>
		<p>Aplicacion no disponible</p>
	</div>
{/if}

<style>
	.toolbar{ background-color:#ddd;}
	.toolbar>li>a{ text-decoration:none;color:#555;font-weight:600;}
	a:hover{ background-color:#efefef;color:#fff;}
</style>